<div>
  <div
    class="mainContentSection"
  >
    <div
      class="backToDuelPopUp"
      (click)="backToDuelModal()"
    >
      <mat-icon
        class="iconBackgroundStyle"
      >
        chevron_left
      </mat-icon>
      <div
        class="linkBackDecoration"
      >
        Назад ко встрече
      </div>
    </div>
    <div
      class="tournamentNameStyle"
    >
      {{getTournamentName()}}
    </div>
    <div
      class="photoAndTable"
    >
      <div>
        <div class="photoContainerSize">
          <img
            src="{{getPlayerPhoto()}}"
            class="imageStyle"
          >
        </div>
        <div
          class="photoCaption"
        >
          <div class="playerNameStyle">
            {{getPlayerPersonalData()?.fullName}}
          </div>
          <div
            class="yearAndTitle"
          >
            {{getPlayerPersonalData()?.birthDate?.split('-')[0] + (getPlayerData()?.title ? (', ' + getPlayerData()?.title) : '')}}
          </div>
          <div
            class="country"
            *ngIf="getPlayerData()?.country"
          >
            {{getPlayerData()?.country}}
          </div>
          <div
            class="city"
            *ngIf="getPlayerData()?.city"
          >
            {{getPlayerData()?.city}}
          </div>
        </div>
      </div>
      <div
        class="tableDiv"
      >
        <table
          mat-table
          [dataSource]="getDuelSeriesFormatted()"
          class="tableSize"
        >
          <ng-container matColumnDef="number">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="tableHeaderCell"
            >
              Номер встречи
            </th>
            <td
              mat-cell
              *matCellDef="let duel"
              class="tableRowCell"
            >
              {{duel.number}}
            </td>
          </ng-container>
          <ng-container matColumnDef="winnerName">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="tableHeaderCell"
            >
            </th>
            <td
              mat-cell
              *matCellDef="let duel"
              class="tableRowCell"
            >
              {{duel.winnerName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="score">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="tableHeaderCell"
            >
              Счёт встречи
            </th>
            <td
              mat-cell
              *matCellDef="let duel"
              class="tableRowCell"
            >
              <div
                class="scoreCellStyle"
                *ngIf="noWalkOver(duel.winnerName, duel.defeatedName)"
              >
                <div
                  [ngClass]="winnerStyle(duel)"
                >
                  {{duel.winnerScore}}
                </div>
                <div
                  class="scoreCell defeatedCell"
                >
                  {{duel.defeatedScore}}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="defeatedName">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="tableHeaderCell"
            >
            </th>
            <td
              mat-cell
              *matCellDef="let duel"
              class="tableRowCell"
            >
              {{duel.defeatedName}}
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="getDisplayedColumns()"
            class="tableHeaderFonts tableHeader"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: getDisplayedColumns();"
            class="tableRow"
          ></tr>
        </table>
      </div>
    </div>
  </div>
</div>
